import { useEffect, useRef } from 'react';
import { AppToaster } from './toaster';

export default function OfflineStatusToast() {
  const toastKeyRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    // Function to show offline toast
    const showOfflineToast = () => {
      // Clear any existing toasts to prevent duplicates
      if (toastKeyRef.current) {
        AppToaster.dismiss(toastKeyRef.current);
      }

      // Show new toast with persistent message
      const toast = AppToaster.show({
        message:
          'You are currently offline. Media access may be limited, and changes may not be saved.',
        intent: 'warning',
        icon: 'warning-sign',
        timeout: 0, // Make it persistent
        isCloseButtonShown: true, // Allow manual dismissal
      });

      toastKeyRef.current = toast;
    };

    // Function to dismiss offline toast
    const dismissOfflineToast = () => {
      if (toastKeyRef.current) {
        AppToaster.dismiss(toastKeyRef.current);
        toastKeyRef.current = undefined;
      }
    };

    // Initial check
    if (!navigator.onLine) {
      showOfflineToast();
    }

    // Add event listeners
    window.addEventListener('online', dismissOfflineToast);
    window.addEventListener('offline', showOfflineToast);

    // Cleanup
    return () => {
      window.removeEventListener('online', dismissOfflineToast);
      window.removeEventListener('offline', showOfflineToast);
      if (toastKeyRef.current) {
        AppToaster.dismiss(toastKeyRef.current);
      }
    };
  }, []);

  return null;
}
